<script setup>
import { computed,reactive } from "vue";
import { useStore } from "vuex";
import { mdiMenu } from "@mdi/js";
import AsideMenuList from "@/components/AsideMenuList.vue";
import NavBarItem from "@/components/NavBarItem.vue";
import Icon from "@/components/Icon.vue";

defineProps({
  menu: {
    type: Array,
    default: () => [],
  },
});

const store = useStore();

const asideStyle = computed(() => store.state.asideStyle);

const asideBrandStyle = computed(() => store.state.asideBrandStyle);

const asideMenuCloseLgStyle = computed(() => store.state.asideMenuCloseLgStyle);

const asideMenuLabelStyle = computed(() => store.state.asideMenuLabelStyle);

const isFullScreen = computed(() => store.state.isFullScreen);

const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded);

const isAsideLgActive = computed(() => store.state.isAsideLgActive);

const asideLgClose = () => {
  store.dispatch("asideLgToggle", false);
};
const menuOpenLg = () => {
  store.dispatch("asideLgToggle");
};
const menuClick = (event, item) => {
  //
};
const styleObjectSideBar = reactive({
  marginLeft: '-180px',
  color:'white'
})
</script>

<template>
  <Transition :duration="{ enter: 500, leave: 800 }">
    <aside  
      v-show="!isFullScreen"
      id="aside"
      class="w-60 px-1 fixed top-0 z-40 h-screen transition-position md:left-0 drop-shadow-lg"
      :class="[
        asideStyle,
        isAsideMobileExpanded ? 'left-0' : '-left-60',
        isAsideLgActive ? 'block xl:-ml-40 lg:ml-0' : 'lg:hidden xl:block ml-0',
      ]"
    >
      <div
        class="flex flex-row w-full flex-1 h-20 px-3 border-b border-gray-60 items-center dark:bg-transparent"
        :class="[asideBrandStyle]"
      >
        <div class="flex-1">
          <!-- <span class="text-lg font-semibold text-black-150">Project Life</span> -->
          <img src="@/assets/icons/label.svg" />
        </div>
        <nav-bar-item
          type="block text-xs lg:flex xl:block"
          @click.prevent="menuOpenLg"
        >
          <img src="@/assets/icons/toggle.svg" />
        </nav-bar-item>
      </div>
      <div>
        <template v-for="(menuGroup, index) in menu">
          <p
            v-if="typeof menuGroup === 'string'"
            :key="`a-${index}`"
            class="p-3 text-xs uppercase"
            :class="[asideMenuLabelStyle]"
          >
            {{ menuGroup }}
          </p>
          <aside-menu-list
            v-else
            :key="`b-${index}`"
            :menu="menuGroup"
            @menu-click="menuClick"
            class="py-3 pb-4 last:border-t border-gray-150"
          />
        </template>
      </div>
    </aside>
  </Transition>
</template>
